"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Listen for specific events on the document
 * Only call the action handler if the event is from an element outside the given elements list
 *
 * Example purpose: Hiding dropdown when clicking outside
 */
class DocumentEventListener {
    constructor(eventName, elements, actionListener) {
        this.eventName = eventName;
        this.actionListener = actionListener;
        this.eventHandler = (event) => {
            if (this.actionListener === undefined) {
                return;
            }
            // check if target is within any of the given elements
            const target = event.target;
            for (const element of elements) {
                if (element.contains(target)) {
                    return;
                }
            }
            this.actionListener();
        };
    }
    /**
     * Set the action listener
     */
    onAction(actionListener) {
        this.actionListener = actionListener;
    }
    /**
     * Enable document listener
     */
    enable() {
        document.addEventListener(this.eventName, this.eventHandler, true);
    }
    /**
     * Disable document listener
     */
    disable() {
        document.removeEventListener(this.eventName, this.eventHandler, true);
    }
}
exports.default = DocumentEventListener;
//# sourceMappingURL=DocumentEventListener.js.map